<template>
  <div class="main">
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <!-- 表头设置控件 -->
      <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" />
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">

      <template #orderNum="params">
        <div class="orderNum"
          :class="(Number(params.params.unton) >= Number(params.params.ton) && Number(params.params.ton) != 0) ? 'excess' : ''">
          {{ params.params.con_num }}
        </div>
      </template>

      <template slot="buttonPD" slot-scope="params">
        <el-button class="dispatchbtn" type="primary" @click="dispatch(params.params)" size="mini">派单</el-button>
      </template>

      <template slot="button" slot-scope="params">
        <el-button class="dispatchbtn shbtn" type="warning" @click="checkConfirm(params.params)"
          :disabled="user.id != params.params.addid" size="mini">完结</el-button>
      </template>
    </Table>

    <ContractDispatch ref="dispatch" @onDispatched="getList" />
  </div>
</template>

<script>
import tableMixin from "@/pages/mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'contract',
      formInline: {
        isstatus: 2,
      },
      formCtrl: [
        {
          label: "合同编号",
          keyName: "con_num",
          placeholder: "请填写合同编号",
          type: "text",
        },
        {
          label: "客户名称",
          keyName: "shname",
          placeholder: "请填写客户名称",
          type: "text",
        },
      ],
      cols: [
        { keyName: "con_num", label: "合同编号", minwidth: 150, slot: 'orderNum' },
        { keyName: "shname", label: "客户名称", minwidth: 150 },
        { keyName: "name", label: "货物名称", minwidth: 120 },
        { keyName: "pricing", label: "计价方式", minwidth: 120 },
        { keyName: "cprice", label: "公司单价", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "dprice", label: "司机单价", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "ton", label: "合同量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "inton", label: "装货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "unton", label: "卸货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "caton", label: "计算量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "starttime", label: "开始日期", minwidth: 120 },
        { keyName: "endtime", label: "结束日期", minwidth: 120 },
        { keyName: "coaddress", label: "装货地址", minwidth: 120 },
        { keyName: "enaddress", label: "卸货地址", minwidth: 120 },
        { keyName: "", label: "派单", slot: 'buttonPD', minwidth: 120 },
        { keyName: "", label: "完结", slot: 'button', minwidth: 120 },
      ],
      btns: [
        {
          icon: 'el-icon-paperclip',
          class: 'fjbtn',
          title: '附件',
          cb: ({ id }) => {
            this.$router.push(
              `/contract/file?id=${id}&mode=edit`
            );
          },
        },
        {
          title: '合同统计',
          img: require('@/assets/img/icon_count.png'),
          unimg: require('@/assets/img/icon_count_hover.png'),
          //class:'countbtn',
          cb: ({ id }) => {
            this.$router.push(
              `/contract/statistics?id=${id}`
            );
          },
        },
        {
          title: '运单列表',
          //icon: 'el-icon-s-order',
          img: require('@/assets/img/icon_order.png'),
          unimg: require('@/assets/img/icon_order_hover.png'),
          cb: ({ id }) => {
            this.$router.push(
              `/contract/orderlist?id=${id}`
            );
          },
        },
        {
          ...this.editBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/contract/detail?id=${id}&mode=edit`
            );
          },
        },
      ],
      baseParams: ['isstatus'],
    };
  },
  methods: {
    dispatch(row) {
      // console.log({ ...row })
      const { id } = row
      this.$router.push(
        `/contract/addorder?contractid=${id}`
      );
      // const dispatch = this.$refs.dispatch
      // if (dispatch && dispatch.show) {
      //   dispatch.mform.contractid = id
      //   dispatch.show()
      // }
    },
    add() {
      this.$router.push(
        `/contract/detail?mode=add`
      );
    },
    checkConfirm({ id }) {
      this.$confirm('完成通过后不可撤销，是否通过完成?', '通过完成', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.checkReq(id);
      }).catch(() => { });
    },
    checkReq(id) {
      this.loading = true
      let url = `${this.baseUrl}/updateisstatus`;
      const params = {
        userid: this.user.id,
        id,
      }
      this.post(url, params, ({ msg }) => {
        this.loading = false
        if (msg == 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '出错了！'
        });
      })
    },
  },
  mounted() {
    this.getList()
    const { user_group_id } = this.user
    if ([2, 3, 4].includes(user_group_id)) {
      // 会计去掉派单列
      this.cols.splice(this.cols.length - 2, 1)
    }
  },
};
</script>

<style lang="less" scoped>
@tuiSize: 15px;

.main {
  .table-wrap {
    /deep/ .el-table {
      .orderNum {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .excess {
        position: relative;

        &::after {
          content: '';
          display: inline-block;
          width: @tuiSize;
          height: @tuiSize;
          background: url(../../../../assets/img/icon_excess.png) no-repeat center center;
          background-size: @tuiSize;
          margin-left: 5px;
        }
      }

      .status {
        &.status1 {
          color: #98e098;
        }

        &.status0 {
          color: #fd5b5b;
        }
      }
    }
  }
}

/deep/ .countbtn:hover {
  background: url(/assets/img/icon_option_01.png) no-repeat right center;
  background-size: 26px;
}

/deep/ .el-table .pr30 .cell {
  padding-right: 30px;
}
</style>
